import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";
import pushDataLayer from "@ocm/services/dataLayer";
import { hideModal } from "./infoModals";

const banderoleEl = document.getElementById("js-banderole");
const cartBanderoleEl = document.getElementById("js-cart-banderole");

const modalId = "js-banderole-modal";
const cartModalId = "js-cart-banderole-modal";
const voucherModalId = "js-voucher-banderole-modal";
const voucherModalEl = document.getElementById(voucherModalId);

let voucherCode = null;
const toastContainerEl = document.getElementById("js-toast-container");
const voucherToastHtml = `<div class="js-toast toast-fade-in-out ocm-subtext2 mb-2 flex items-center rounded-[0.5714285rem] bg-success p-2.5 text-white">
	<svg class="svg-icon mr-2.5 h-7 w-7 shrink-0" aria-hidden="true">
		<use xlink:href="#icon-checkmark-circled" href="#icon-checkmark-circled"></use>
	</svg>
	Gutscheincode wurde kopiert
</div>`;

OcmMessenger.subscribe(messengerPublicationTypes.ROUTE_CHANGE_MOUNTED_APPS, ({ data: { mountedApps } }) => {
	if (mountedApps.includes("mf-cart")) {
		_hide(banderoleEl);
		_slideIn(cartBanderoleEl);
		return;
	}
	_hide(cartBanderoleEl);
	_slideIn(banderoleEl);
});

function _isCartPage() {
	return window.location.pathname.includes("/cart");
}

/*
interface show {
	content: Array<string | {
		text?: string
		bold?: boolean = false
		infoIcon?: false
		link?: string
		voucherCode?: string
	}>,
	modal: {
		headline: string
		text: string
	}
}

examples of usage for gtm in TUB-12463 and TUB-18096
*/

function show({ content, modal }) {
	banderoleEl.innerHTML = _getContentTemplate(content, modalId);
	_addModalContent(modal, modalId);

	const message = content.find((item) => item.text && !item.link)?.text ?? null;
	if (message) {
		document.querySelector("[data-track-banderole]")?.addEventListener("click", (e) => {
			e.preventDefault();
			pushDataLayer({
				event: "GAevent",
				event_category: "Banderole",
				event_action: message,
				event_label: window.recommendationData?.Recommendation?.pageData?.pagePath ?? null,
			});
			window.location.assign(e.currentTarget.href);
		});
	}

	_isCartPage() ? _hide(banderoleEl) : _slideIn(banderoleEl);
}

function showVoucher({ content, modal }) {
	if (!modal) return;

	voucherCode = content.find((item) => item.voucherCode)?.voucherCode ?? null;
	if (!voucherCode) return;

	banderoleEl.innerHTML = _getContentTemplate(content, voucherModalId);
	voucherModalEl.querySelector(".js-voucher-modal-text").innerText = modal.text ?? "";
	voucherModalEl.querySelector(".js-voucher-modal-input").value = voucherCode;
	voucherModalEl.querySelector(".js-voucher-modal-legal").innerText = modal.legal ?? "";
	voucherModalEl.querySelector(".js-voucher-modal-copy").addEventListener("click", _copyToClipboard);

	banderoleEl.querySelector("[data-track-voucher=show]").addEventListener("click", _trackVoucherModal);
	voucherModalEl.querySelector("[data-track-voucher=copy]").addEventListener("click", _trackVoucherModal);

	_isCartPage() ? _hide(banderoleEl) : _slideIn(banderoleEl);
}

function showCart({ content, modal }) {
	cartBanderoleEl.innerHTML = _getContentTemplate(content, cartModalId);
	_addModalContent(modal, cartModalId);
	_slideIn(cartBanderoleEl);
}

function _slideIn(el) {
	if (el.hasChildNodes()) {
		el.style.display = "block";
		requestAnimationFrame(() => el.classList.add("slided-in"));
	}
}

function _hide(el) {
	el.style.display = "none";
	el.classList.remove("slided-in");
}

function _addModalContent(modal, id) {
	if (!modal) return;

	const modalEl = document.getElementById(id);
	modalEl.querySelector(".info-modal__header").innerText = modal.headline;
	modalEl.querySelector(".info-modal__body").innerText = modal.text;
}

function _getContentTemplate(content, modalId) {
	return (
		content
			// eslint-disable-next-line complexity
			.map((contentItem) => {
				if (typeof contentItem === "string") return contentItem;

				let formattedText =
					contentItem.bold && contentItem.text
						? `<strong class="font-semibold">${contentItem.text}</strong>`
						: contentItem.text || "";

				if (contentItem.link) {
					formattedText = `<a href="${contentItem.link}" class="c-banderole__link underline lg:ml-3" data-track-banderole>${formattedText}</a>`;
				}

				if (contentItem.infoIcon) {
					formattedText += `
						<svg
							onclick='document.getElementById("${modalId}").classList.add("is-visible");'
							class="svg-icon ml-2 cursor-pointer text-gray-60"
						>
							<use href="#icon-info"></use>
						</svg>
					`;
				}

				if (contentItem.voucherCode) {
					formattedText = `
						<button
							type="button"
							class="underline"
							onclick='document.getElementById("${modalId}").classList.add("is-visible");'
							data-track-voucher="show"
						>Gutscheincode anzeigen</button>
					`;
				}

				// span wrapper is for smooth line breaks without infoIcon on a separate line
				return contentItem.infoIcon
					? `<span class="inline-flex items-center whitespace-nowrap">${formattedText}</span>`
					: formattedText;
			})
			.join("")
	);
}

const _copyToClipboard = async () => {
	if (!voucherCode) return;

	try {
		await navigator.clipboard.writeText(voucherCode);
		hideModal(voucherModalEl);
		setTimeout(_showToast, 360);
	} catch (error) {
		console.error("Writing to clipboard failed", error);
	}
};

const _trackVoucherModal = ({ target }) => {
	pushDataLayer({
		event: "GAevent",
		event_category: "Banderole",
		event_action: `${target.dataset.trackVoucher}_${voucherCode}`,
		event_label: window.recommendationData?.Recommendation?.pageData?.pagePath ?? null,
	});
};

const _showToast = () => {
	toastContainerEl.insertAdjacentHTML("beforeend", voucherToastHtml);
	const toastEl = toastContainerEl.lastElementChild;
	setTimeout(() => {
		toastEl.remove();
	}, 2900);
};

export { show, showVoucher, showCart };
